/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React Button Styles
import root from "assets/theme/components/button/root";
import contained from "assets/theme/components/button/contained";
import outlined from "assets/theme/components/button/outlined";
import buttonText from "assets/theme/components/button/text";
import colors from "assets/theme/base/colors";
import rgba from "assets/theme/functions/rgba";

const { white } = colors;

const button = {
  defaultProps: {
    disableRipple: false,
  },
  styleOverrides: {
    root: { ...root },
    contained: { ...contained.base },
    containedSizeSmall: { ...contained.small },
    containedSizeLarge: { ...contained.large },
    containedPrimary: { ...contained.primary },
    containedSecondary: { ...contained.secondary },
    outlined: { ...outlined.base },
    outlinedSizeSmall: { ...outlined.small },
    outlinedSizeLarge: { ...outlined.large },
    outlinedPrimary: { ...outlined.primary },
    outlinedSecondary: { ...outlined.secondary },
    text: { ...buttonText.base },
    textSizeSmall: { ...buttonText.small },
    textSizeLarge: { ...buttonText.large },
    textPrimary: { ...buttonText.primary },
    textSecondary: { ...buttonText.secondary },

    // --- FIX CONTRASTE GLOBAL PARA color="inherit" ---
    textInherit: {
      color: white.main,
      opacity: 1,
      "&:hover": {
        backgroundColor: rgba(white.main, 0.12),
      },
    },
    outlinedInherit: {
      color: white.main,
      borderColor: rgba(white.main, 0.55),
      "&:hover": {
        borderColor: rgba(white.main, 0.9),
        backgroundColor: rgba(white.main, 0.1),
      },
    },
    containedInherit: {
      color: white.main,
      backgroundColor: rgba(white.main, 0.16),
      "&:hover": {
        backgroundColor: rgba(white.main, 0.24),
      },
    },
  },
};

export default button;
